import { FC, ReactNode } from 'react'
import { Container, ContainerProps } from '@mui/material'

export interface AppContainerProps extends ContainerProps {
  children: ReactNode
}

export const AppContainer: FC<AppContainerProps> = ({ children, sx }) => {
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        ...sx,
      }}
    >
      {children}
    </Container>
  )
}

// The container is made its own for disableGutters and maxWidth={false}, 
// because this cannot be written in the theme, only in the Container itself